import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import Cssbaseline from '@mui/material/CssBaseline';
import { theme } from '@ace/ace-ui-web';
import { Provider } from 'react-redux';
import store from './redux/store';
import { initializeDatadog } from './utils/dataDogInit';

initializeDatadog();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Cssbaseline />
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
);
